import ProductService from '@/services/ProductService.js'

export const state = {
  products: [],
  product: {}
}

export const mutations = {
  ADD_PRODUCT(state, product) {
    state.products.push(product)
  },
  DELETE_PRODUCT(state, product) {
    state.products = state.products.filter(t => t.id != product.id)
  },
  EDIT_PRODUCT(state, product) {
    state.product = product
  },
  SET_PRODUCTS(state, products) {
    state.products = products
  },
  SET_PRODUCT(state, product) {
    state.product = product
  }
}

export const namespaced = true //all mutations, actions, getters will be namespaced under "Product"//

export const actions = {
  createProduct({ commit, dispatch }, product) {
    return ProductService.postProduct(product)
      .then(response => {
        commit('ADD_PRODUCT', product)
        const notification = {
          type: 'success',
          message: 'Your new product has been created!'
        }
        dispatch('notification/add', notification, { root: true })
        return response.data
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem creating your product: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  fetchProducts({ commit, dispatch }) {
    ProductService.getProducts()
      .then(response => {
        commit('SET_PRODUCTS', response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching products: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  searchProducts({ commit, dispatch }, searchTerm) {
    ProductService.searchProducts(searchTerm)
      .then(response => {
        commit('SET_PRODUCTS', response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem searching products: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
      })
  },
  fetchProduct({ commit, getters }, id) {
    var product = getters.getProductById(id)

    if (product) {
      commit('SET_PRODUCT', product)
      return product
    } else {
      return ProductService.getProduct(id) // <-- Send the prop id to our ProductService//
        .then(response => {
          commit('SET_PRODUCT', response.data)
          return response.data[0]
        })
    }
  },
  async removeProduct({ commit }, product) {
    return ProductService.deleteProduct(product)
    .then((response) => {
      if (response.data.success === true) {
        commit('DELETE_PRODUCT', product)
      } else {
        alert(response.data.message)
      }
    })
    .catch(error => {
      throw error
    })
  },
  editProduct({ commit }, product) {
    ProductService.updateProduct(product)
    commit('EDIT_PRODUCT', product)
  },
  addProductShippingDetails({ dispatch }, shippingDetails) {
    return ProductService.addClientShippingDetail(shippingDetails)
      .then(() => {
        const notification = {
          type: 'success',
          message: 'Details saved successfully!'
        }
        dispatch('notification/add', notification, { root: true })
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching clients: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  addProductWholesaleDetails( { dispatch }, wholesaleDetails) {
    return ProductService.addProductWholesaleDetail(wholesaleDetails)
      .then(() => {
        const notification = {
          type: 'success',
          message: 'Details saved successfully!'
        }
        dispatch('notification/add', notification, { root: true })
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching clients: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        throw error
      })
  },
  saveProductVideoUrl({ dispatch }, videoData) {
    return ProductService.saveProductVideoUrl(videoData)
    .then((response) => {
      return response
    })
    .catch(error => {
      const notification = {
        type: 'error',
        message: 'There was a problem saving video url: ' + error.message
      }
      dispatch('notification/add', notification, { root: true })
      throw error
    })
  },
  fetchProductStock({ dispatch }) {
    return new Promise((resolve, reject) => {
      ProductService.getProductStock()
      .then(response => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem fetching product stock: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        reject(error)
      })
    })
  },
  searchProductStock({ dispatch }, searchTerm) {
    return new Promise((resolve, reject) => {
      ProductService.searchProductStock(searchTerm)
      .then(response => {
        return resolve(response.data)
      })
      .catch(error => {
        const notification = {
          type: 'error',
          message: 'There was a problem searching product stock: ' + error.message
        }
        dispatch('notification/add', notification, { root: true })
        reject(error)
      })
    })
  }
}

export const getters = {
  getProductById: state => id => {
    return state.products.find(product => product.id === id)
  }
}
